"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveRequestParamValue = void 0;
var index_1 = require("../../../index");
var Http_service_1 = require("../../../core/services/http/Http.service");
var BSSRetry_1 = require("./BSSRetry");
var defaultHeadersResolver_1 = __importDefault(require("./defaultHeadersResolver"));
var resolvers_1 = __importDefault(require("./resolvers"));
var refHash = {};
function validateParams(param, value) {
    if (param.required) {
        if (value === undefined || value === null) {
            throw new Error("parameter[" + param.name + ":" + param.type + "] is required");
        }
    }
    // if (param.type) // TODO, validate type
    // if (param.schema) // TODO, validate schema
}
function resolveRequestParamValue(paramsInput, paramDefined) {
    if (paramsInput === void 0) { paramsInput = {}; }
    if (paramsInput[(paramDefined === null || paramDefined === void 0 ? void 0 : paramDefined.name) || ''] !== undefined) {
        return paramsInput[(paramDefined === null || paramDefined === void 0 ? void 0 : paramDefined.name) || ''];
    }
    return paramDefined === null || paramDefined === void 0 ? void 0 : paramDefined.default;
}
exports.resolveRequestParamValue = resolveRequestParamValue;
/*
  type: 'path' | 'query' | 'body' | 'header'
*/
function resolveParams(type, parameters, args) {
    return parameters
        .filter(function (param) { return param.in === type; })
        .reduce(function (map, param) {
        var _a;
        // if has not default param, use the setting param direactly.
        var value = resolveRequestParamValue(args, param);
        if (((args === null || args === void 0 ? void 0 : args.ignoreNullQueryParams) || false) && !value) {
            return __assign({}, map);
        }
        validateParams(param, value);
        return __assign(__assign({}, map), (_a = {}, _a[param.name || ''] = value, _a));
    }, {});
}
function resolveBSSParams(type, parameters, args) {
    return parameters
        .filter(function (param) { return param.in === type; })
        .reduce(function (map, param) {
        var _a;
        // if has not default param, use the setting param direactly.
        var value = resolveRequestParamValue(args, param);
        if (!value) {
            return __assign({}, map);
        }
        validateParams(param, value);
        return __assign(__assign({}, map), (_a = {}, _a[param.name || ''] = value, _a));
    }, {});
}
function resolveRefParams(appName, version, parameters) {
    parameters
        .filter(function (param) { return !!param.$ref; })
        .forEach(function (param) {
        var refPath = param.$ref;
        if (!refPath) {
            throw new Error("There is no such a parameter - " + param.$ref + ".");
        }
        parameters.push(refHash[appName][version][refPath]);
    });
}
function resolvePath(path, parameters, args) {
    var paramMap = resolveParams('path', parameters, args);
    return path.replace(/\{(\w+)\}/g, function (_, paramName) { return paramMap[paramName] || ''; });
}
function buildUrl(protocalResolver, domainResolver, appName, serviceName, version, basePath, path, verb, parameters, args) {
    return __awaiter(this, void 0, void 0, function () {
        var scheme, domain, fixedPath, paramMap, query;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    resolveRefParams(appName, version, parameters); // resolveRefParams before resolveParams
                    scheme = protocalResolver(appName, version, path);
                    return [4 /*yield*/, domainResolver()];
                case 1:
                    domain = _a.sent();
                    fixedPath = resolvePath(path, parameters, args);
                    paramMap = {};
                    // temporary code for bss special case, query params shouldn't in url if have no value
                    if (appName === 'bss') {
                        paramMap = resolveBSSParams('query', parameters, args);
                    }
                    else {
                        paramMap = resolveParams('query', parameters, args); // TODO, No array parameters, right?
                    }
                    query = Object.keys(paramMap)
                        .map(function (key) { return [encodeURIComponent(key), encodeURIComponent(paramMap[key])].join('='); })
                        .join('&');
                    // `query` must be a string
                    query = query.length > 0 ? "?" + query : '';
                    return [2 /*return*/, scheme + "://" + domain + (basePath || '') + fixedPath + query];
            }
        });
    });
}
function buildFormDataBody(args, body) {
    if (typeof window.FormData !== 'function')
        return undefined;
    var formData = new window.FormData();
    body.forEach(function (item) {
        validateParams(item, args[item.name || '']);
        var value = args[item.name || ''];
        var formItem;
        if (value instanceof window.Blob) {
            formItem = value;
        }
        else {
            formItem = value && typeof value === 'string' ? value : JSON.stringify(value);
        }
        formData.append(item.name || '', formItem);
    });
    return formData;
}
function buildOrdinaryBody(args, body) {
    var value = args[body.name || ''];
    validateParams(body, value);
    if (value instanceof window.Blob) {
        return value;
    }
    return value && typeof value === 'string' ? value : JSON.stringify(value);
}
function buildBody(parameters, args) {
    var ordinaryBody = parameters.filter(function (p) { return p.in === 'body'; })[0];
    if (ordinaryBody) {
        return buildOrdinaryBody(args, ordinaryBody);
    }
    var formDataBody = parameters.filter(function (p) { return p.in === 'formData'; });
    if (Array.isArray(formDataBody) && formDataBody.length) {
        // Current Browser compatibility: ie >= 10  chrome >=7 edge>=12 opera>=12 safari >=5. We will consider compatibility below ie10
        return buildFormDataBody(args, formDataBody);
    }
    return undefined;
}
function defaultProtocalResolver() {
    return 'https';
}
function JSONParse(str) {
    var result = '';
    try {
        result = JSON.parse(str);
    }
    catch (e) {
        return str;
    }
    return result;
}
// eslint-disable-next-line no-unused-vars
function defaultShouldRetry(httpStatusCode, retryHttpStatusCodeList) {
    return retryHttpStatusCodeList.includes(httpStatusCode);
}
function getOptionsWithDefaultValues(options) {
    var _a = options || {}, _b = _a.isLibraryService, isLibraryService = _b === void 0 ? false : _b, _c = _a.preventGlobalErrorDialog, preventGlobalErrorDialog = _c === void 0 ? false : _c, _d = _a.retryTimes, retryTimes = _d === void 0 ? 0 : _d, _e = _a.enableRetry, enableRetry = _e === void 0 ? false : _e, _f = _a.maxRetryTimes, maxRetryTimes = _f === void 0 ? 5 : _f, _g = _a.retryInterval, retryInterval = _g === void 0 ? 5000 : _g, _h = _a.shouldRetry, shouldRetry = _h === void 0 ? defaultShouldRetry : _h, _j = _a.retryHttpStatusCodeList, retryHttpStatusCodeList = _j === void 0 ? [0, 408, 500, 503] : _j;
    return {
        isLibraryService: isLibraryService,
        preventGlobalErrorDialog: preventGlobalErrorDialog,
        retryTimes: retryTimes,
        enableRetry: enableRetry,
        maxRetryTimes: maxRetryTimes,
        retryInterval: retryInterval,
        shouldRetry: shouldRetry,
        retryHttpStatusCodeList: retryHttpStatusCodeList,
    };
}
// eslint-disable-next-line camelcase
function defaultAPIService(apiOptions, retryCallback, _a, options) {
    var request_metadata = _a.request_metadata;
    var _b = getOptionsWithDefaultValues(options), isLibraryService = _b.isLibraryService, preventGlobalErrorDialog = _b.preventGlobalErrorDialog;
    var httpService = index_1.instance.getService(Http_service_1.HttpService);
    return httpService.request(__assign(__assign({}, apiOptions), { interceptors: options === null || options === void 0 ? void 0 : options.interceptors, responseContentType: options === null || options === void 0 ? void 0 : options.responseContentType, 
        /**
         * `createAPISDK` has it's own way to set header.
         * Consumer can control if it includes global headers and custom headers.
         * In some case, the final desired headers may don't contain global headers.
         * We have to let http.service.ts ignore the global headers.
         */
        ignoreGlobalHeaders: true, isLibraryService: isLibraryService,
        retryCallback: retryCallback,
        preventGlobalErrorDialog: preventGlobalErrorDialog, dirtySolutionErrorHandler: function (status, result, innerGlobalErrorHandler) {
            return new Promise(function (resolve, reject) {
                var _a = getOptionsWithDefaultValues(options), retryTimes = _a.retryTimes, enableRetry = _a.enableRetry, maxRetryTimes = _a.maxRetryTimes, retryInterval = _a.retryInterval, shouldRetry = _a.shouldRetry, retryHttpStatusCodeList = _a.retryHttpStatusCodeList;
                var runErrorHandler = function () {
                    if (apiOptions.errorHandlers && apiOptions.errorHandlers[status]) {
                        var errorMsg = "" + result;
                        var err = new Error(errorMsg);
                        var rejectResult = {
                            //default
                            Message: "Unexpected error: " + errorMsg,
                            OriginalError: __assign(__assign({}, err), { errorCode: status }),
                        };
                        try {
                            //catch exception thrown from handler
                            apiOptions.errorHandlers[status](retryCallback, resolve, reject, result);
                        }
                        catch (handlerErr) {
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            rejectResult = __assign(__assign({}, rejectResult), handlerErr); //override by handler thrown
                        }
                        reject(rejectResult); //reject to trigger msg box
                    }
                    else if (innerGlobalErrorHandler) {
                        innerGlobalErrorHandler().then(resolve).catch(reject);
                    }
                };
                var url = apiOptions.url;
                if (enableRetry) {
                    if (shouldRetry(status, retryHttpStatusCodeList, result) && retryTimes < maxRetryTimes) {
                        setTimeout(function () {
                            retryCallback().then(resolve).catch(reject);
                        }, retryInterval);
                    }
                    else {
                        runErrorHandler();
                    }
                }
                else if (BSSRetry_1.BSSRetry(status, url)) {
                    // eslint-disable-next-line camelcase
                    var index = request_metadata && request_metadata.index;
                    if (BSSRetry_1.limitRequestTimes.limit5Times(url, index)) {
                        setTimeout(function () {
                            retryCallback().then(resolve).catch(reject);
                        }, 5000);
                    }
                    else {
                        reject({
                            Message: "Unknown status: " + status + ", body: " + JSON.stringify(result),
                        });
                    }
                }
                else {
                    runErrorHandler();
                }
            });
        } }));
}
function createAPIHandler(appName, version, basePath, path, verb, parameters, _a) {
    var _this = this;
    var credentials = _a.credentials, _b = _a.debug, debug = _b === void 0 ? false : _b, 
    // @deprecated
    apiService = _a.apiService, serviceName = _a.serviceName, 
    // @deprecated
    protocalResolver = _a.protocalResolver, 
    // @deprecated
    context = _a.context, 
    // @deprecated
    globalErrorHandlers = _a.globalErrorHandlers, 
    // @deprecated
    domainResolver = _a.domainResolver, customHeadersResolver = _a.customHeadersResolver, ignoreDeprecatedWarning = _a.ignoreDeprecatedWarning;
    var handler = function (params, options) { return __awaiter(_this, void 0, void 0, function () {
        var resolvers, canAccept, _a, retryTimes, enableRetry, maxRetryTimes, retryInterval, shouldRetry, retryHttpStatusCodeList, fixedParams, url, defaultHeaders, globalHeaders, paramsInHeaders, headers, apiOptions, resend;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (debug) {
                        console.info('> params: ', params, '> options: ', options); // eslint-disable-line no-console
                    }
                    if (!serviceName) {
                        if (!ignoreDeprecatedWarning) {
                            console.warn('WARN serviceName will soon be required if you are using a non default domain for your request. If your request goes to https://{tenant}.seismic.com then you will not need this.');
                        }
                    }
                    if (protocalResolver) {
                        if (!ignoreDeprecatedWarning) {
                            console.warn('WARN from createAPISDK, `protocalResolver` is deprecated, will be remove soon. You should always leave it as default as `https`.');
                        }
                    }
                    else {
                        protocalResolver = defaultProtocalResolver;
                    }
                    resolvers = resolvers_1.default();
                    if (context) {
                        if (!ignoreDeprecatedWarning) {
                            console.warn('WARN from createAPISDK, `context` is deprecated, will be remove soon. Now createAPISDK is able to figure out the context and context.authToken by itself.');
                        }
                    }
                    else {
                        context = { authToken: resolvers.authTokenResolver };
                    }
                    if (globalErrorHandlers) {
                        if (!ignoreDeprecatedWarning) {
                            console.warn('WARN from createAPISDK, `globalErrorHandlers` is deprecated, will be remove soon. Now createAPISDK is able to figure out the globalErrorHandlers by itself.');
                        }
                    }
                    else {
                        // No need global error handlers, HttpService will take care of this
                    }
                    if (domainResolver) {
                        if (!ignoreDeprecatedWarning) {
                            console.warn('WARN from createAPISDK, `domainResolver` is deprecated, will be remove soon. Now createAPISDK is able to figure out the domainResolver by itself.');
                        }
                    }
                    else {
                        domainResolver = function () { return resolvers.domainResolver(appName, serviceName); };
                    }
                    customHeadersResolver !== null && customHeadersResolver !== void 0 ? customHeadersResolver : (customHeadersResolver = resolvers.customHeadersResolver);
                    canAccept = params === undefined || (params !== null && typeof params === 'object');
                    if (!canAccept) {
                        throw new Error('params has to be undefined or a plain object');
                    }
                    _a = getOptionsWithDefaultValues(options), retryTimes = _a.retryTimes, enableRetry = _a.enableRetry, maxRetryTimes = _a.maxRetryTimes, retryInterval = _a.retryInterval, shouldRetry = _a.shouldRetry, retryHttpStatusCodeList = _a.retryHttpStatusCodeList;
                    fixedParams = params === undefined ? {} : params;
                    return [4 /*yield*/, buildUrl(protocalResolver, domainResolver, appName, serviceName, version, basePath, path, verb, parameters, fixedParams)];
                case 1:
                    url = _b.sent();
                    defaultHeaders = defaultHeadersResolver_1.default(context, debug);
                    globalHeaders = typeof customHeadersResolver === 'function'
                        ? customHeadersResolver(context, defaultHeaders)
                        : defaultHeaders;
                    paramsInHeaders = resolveParams('header', parameters, __assign(__assign({}, fixedParams), globalHeaders));
                    headers = __assign(__assign({}, globalHeaders), paramsInHeaders);
                    apiOptions = {
                        method: verb,
                        headers: headers,
                        mode: 'cors',
                        body: buildBody(parameters, fixedParams),
                        credentials: credentials,
                    };
                    if (!apiService) {
                        resend = function () {
                            return handler(params, __assign(__assign({}, options), { retryTimes: retryTimes + 1 }));
                        };
                        return [2 /*return*/, defaultAPIService(__assign(__assign({}, apiOptions), { url: url, errorHandlers: globalErrorHandlers }), resend, fixedParams, options)];
                    }
                    /*
                    call --> if success (status >= 200 && status < 400)
                                |
                                |--> [Y] --> resolve(json)
                                |
                                |--> [N] --> if exists handler?
                                                |
                                                |--> [N] --> reject(json)
                                                |
                                                |--> [Y] --> handler(resend, resolve, reject, result)
                    */
                    return [2 /*return*/, new Promise(function (resolve, reject) {
                            apiService(url, apiOptions, options)
                                .then(function (response) {
                                if (debug) {
                                    console.log('> Response: ', response);
                                }
                                return response
                                    .text()
                                    .then(function (result) { return [response.status, result === '' ? result : JSONParse(result)]; });
                            })
                                .then(function (_a) {
                                var _b = __read(_a, 2), status = _b[0], result = _b[1];
                                if (debug) {
                                    console.info('> Status: ', status, ' Result: ', result); // eslint-disable-line no-console
                                }
                                if (status >= 200 && status < 400) {
                                    resolve(result);
                                    return;
                                }
                                var resend = function (newParams) {
                                    return handler(Object.assign({}, params, newParams), __assign(__assign({}, options), { retryTimes: retryTimes + 1 }));
                                };
                                if (enableRetry) {
                                    if (shouldRetry(status, retryHttpStatusCodeList, result) && retryTimes < maxRetryTimes) {
                                        setTimeout(function () {
                                            resend().then(resolve).catch(reject);
                                        }, retryInterval);
                                        return;
                                    }
                                }
                                else if (BSSRetry_1.BSSRetry(status, url)) {
                                    var index = (params === null || params === void 0 ? void 0 : params.request_metadata) && (params === null || params === void 0 ? void 0 : params.request_metadata.index);
                                    if (BSSRetry_1.limitRequestTimes.limit5Times(url, index)) {
                                        setTimeout(function () {
                                            resend().then(resolve).catch(reject);
                                        }, 1000);
                                        return;
                                    }
                                    reject({
                                        Message: "Unknown status: " + status + ", body: " + JSON.stringify(result),
                                    });
                                }
                                if (status >= 400) {
                                    /**
                                     * error body structure
                                     * ```
                                     *  {
                                     *    "Status": "string",
                                     *    "Application": "string",
                                     *    "Type": "string",
                                     *    "Message": "string"
                                     *  }
                                     * ```
                                     */
                                    var errorHandler = (globalErrorHandlers || {})[status];
                                    if (typeof errorHandler === 'function') {
                                        errorHandler(resend, resolve, reject, result);
                                        return;
                                    }
                                    reject(result);
                                    return;
                                }
                                reject({
                                    Message: "Unknown status: " + status + ", body: " + JSON.stringify(result),
                                });
                            })
                                .catch(function (e) {
                                if (debug) {
                                    console.info('> Error on service call:\n', e); // eslint-disable-line no-console
                                }
                                var resend = function (newParams) {
                                    return handler(Object.assign({}, params, newParams), __assign(__assign({}, options), { retryTimes: retryTimes + 1 }));
                                };
                                if (enableRetry) {
                                    if (shouldRetry(BSSRetry_1.NETWORK_ERR_STATUS, retryHttpStatusCodeList, e) && retryTimes < maxRetryTimes) {
                                        setTimeout(function () {
                                            resend().then(resolve).catch(reject);
                                        }, retryInterval);
                                        return;
                                    }
                                }
                                else if (BSSRetry_1.BSSRetry(BSSRetry_1.NETWORK_ERR_STATUS, url)) {
                                    var index = (params === null || params === void 0 ? void 0 : params.request_metadata) && (params === null || params === void 0 ? void 0 : params.request_metadata.index);
                                    if (BSSRetry_1.limitRequestTimes.limit5Times(url, index)) {
                                        setTimeout(function () {
                                            resend().then(resolve).catch(reject);
                                        }, 5000);
                                        return;
                                    }
                                    reject({
                                        Message: "Unexpected error: " + JSON.stringify(e),
                                        OriginalError: e,
                                    });
                                }
                                reject({
                                    Message: "Unexpected error: " + JSON.stringify(e),
                                    OriginalError: e,
                                });
                            });
                        })];
            }
        });
    }); };
    return handler;
}
function ensureRefHashAvailable(appName, version) {
    if (!refHash[appName]) {
        refHash[appName] = {};
    }
    if (!refHash[appName][version]) {
        refHash[appName][version] = {};
    }
}
function constructRefHash(appName, version, schema) {
    if (!schema.parameters)
        return;
    ensureRefHashAvailable(appName, version);
    Object.keys(schema.parameters).forEach(function (param) {
        var hashKey = "#/parameters/" + param;
        if (!refHash[appName][version][hashKey]) {
            refHash[appName][version][hashKey] = schema.parameters[param];
        }
    });
}
function createAPIHandlers(appName, version, schema, config) {
    var basePath = schema.basePath;
    if (!basePath) {
        console.warn("No [basePath] in the swagger spec file for " + appName + "@v" + version);
    }
    if (!schema.paths) {
        throw new Error("No [paths] in the swagger spec file for " + appName + "@v" + version);
    }
    constructRefHash(appName, version, schema);
    return Object.keys(schema.paths).reduce(function (apis, path) {
        var results = __assign({}, apis);
        var pathMap = schema.paths[path];
        Object.keys(pathMap).forEach(function (verb) {
            var verbMap = pathMap[verb];
            results[verbMap.operationId] = createAPIHandler(appName, version, basePath, path, verb, verbMap.parameters, config);
        });
        return results;
    }, {});
}
/**
 * <h4>createAPISDK</h4>
 * <h5>Example for initializing</h5>
 * <p>You may have a file</p>
 * ```javascript
 * // apiUtils.js
 * import createAPISDK from './createAPISDK';
 * import seismicSwaggerSpec from './seismicswaggerspec';
 *
 * function initialize(authToken, globalErrorHandlers) {
 *     console.info('initializing...');
 *     return createAPISDK({
 *         globalErrorHandlers,
 *         schema: seismicSwaggerSpec,
 *         context: {
 *             authToken
 *         }
 *     });
 * }
 *
 * export default initialize('someToken', {
 *     SessionTimeOut: () => {
 *         console.error('User Session Time Out');
 *     }
 * });
 * ```
 * <h5>Example for usage</h5>
 * ```javascript
 * import apiUtils from './apiUtils';
 *
 * ...
 *     this.setState({ loading: true, result: null, error: null });
 *     apiUtils.dc['1.1'].getUserById({ userId: id })
 *         .then((result) => {
 *             this.setState({
 *                 loading: false,
 *                 result,
 *                 error: null
 *             });
 *         })
 *         .catch((error) => {
 *             this.setState({
 *                 loading: false,
 *                 result: null,
 *                 error
 *             });
 *         });
 * ```
 * @namespace Seismic.createAPISDK
 */
var createAPISDKV2 = function (config) {
    if (!config)
        throw new Error('config is required of createAPISDKV2');
    var schema = config.schema;
    if (!schema)
        throw new Error('config.schema is required of createAPISDKV2');
    var api = Object.keys(schema).reduce(function (all, appName) {
        var _a;
        return (__assign(__assign({}, all), (_a = {}, _a[appName] = Object.keys(schema[appName]).reduce(function (ver, version) {
            var _a;
            return (__assign(__assign({}, ver), (_a = {}, _a[version] = createAPIHandlers(appName, version, schema[appName][version], config), _a)));
        }, {}), _a)));
    }, {});
    return api;
};
exports.default = createAPISDKV2;
//# sourceMappingURL=createAPISDKV2.js.map